// import React, {useEffect, useRef, useState} from 'react';
// import './UserMenu.css';
// import { useAuth } from '../firebase/AuthContext';
// import PasswordChange from '../PasswordChange/PasswordChange';
// import {NavLink, useLocation, useNavigate} from "react-router-dom";
// import Tracker from '../Tracker/Tracker';

// const UserMenu = ({ onLogout }) => {
// const { user, closeMenu } = useAuth();
// const menuRef = useRef(null); // Reference for the menu list container
// const navigate = useNavigate();

//  // Extract username with number from email
// //  const currentUserName = user?.email?.split('@')[0] || "User";

// // Extract alphabet username from email 
// const currentUserName = user?.email 
//     ? user.email.split('@')[0].match(/[a-zA-Z]+/g)?.join('') || "User"
//     : "User";

// // Capitalize first letter of current user name
// const capitalizedcurrentUserName = currentUserName 
//     ? currentUserName.charAt(0).toUpperCase() + currentUserName.slice(1) 
//     : "User";


// // Close the menu if clicked outside of it
// useEffect(() => {
//     const handleOutsideClick = (e) => {
//         // Check if the click is outside the menu
//         if (menuRef.current && !menuRef.current.contains(e.target)) {
//             closeMenu(); // Close the menu if clicked outside
//         }
//     };

//     // Only add the event listener if the menu is open
//     document.addEventListener('click', handleOutsideClick);

//     return () => {
//         document.removeEventListener('click', handleOutsideClick);
//     };
// }, [closeMenu]);

// const handleUserName= () => {
//     alert(`Hello, ${capitalizedcurrentUserName}! We hope you're having a great day! 😊`);
// };

// const handlePasswordChange = () =>{
//     navigate('/password_change');
//     closeMenu();
// }

// const handleTracker = () =>{
//     navigate('/tracker');
//     closeMenu();
// }
    
//     return (
//         <div className='user-menu-container' ref={menuRef}>
//             <div className='user-menu-header'>
//               <h3 className='user-welcome'
//                   onClick={handleUserName}>
//                 Welcome! {capitalizedcurrentUserName}
//               </h3>
//               {/* <i class="ri-close-circle-line"
//                 onClick={closeMenu}>
//               </i> */}
//             </div>
            
            
//             <ul className='user-menu-list'>
//                 {/* <li onClick={handleTracker}>
//                     <i class="ri-truck-line"></i>
//                     Track Order
//                 </li> */}
//                 <li onClick={handlePasswordChange}>
//                     <i class="ri-lock-password-line" />
//                     Change Password
//                 </li>
//                 <li onClick={onLogout}>
//                     <i class="ri-logout-circle-r-line" />
//                     Logout
//                 </li>
//             </ul>
//         </div>
//     );
// };

// export default UserMenu;



// import React, { useEffect, useRef, useState } from 'react';
// import './UserMenu.css';
// import { useAuth } from '../firebase/AuthContext';
// import PasswordChange from '../PasswordChange/PasswordChange';
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import Tracker from '../Tracker/Tracker';
// import { doc, getDoc } from 'firebase/firestore'; // Firestore functions
// import { db } from '../firebase/firebase'; // Firestore instance

// const UserMenu = ({ onLogout }) => {
//   const { user, closeMenu } = useAuth();
//   const menuRef = useRef(null); // Reference for the menu list container
//   const navigate = useNavigate();
//   const [firestoreUsername, setFirestoreUsername] = useState(''); // State for Firestore username

//   // Fetch username from Firestore
//   useEffect(() => {
//     const fetchUsername = async () => {
//       if (user) {
//         const userDoc = await getDoc(doc(db, "users", user.uid)); // Firestore se user data fetch karna
//         if (userDoc.exists()) {
//           setFirestoreUsername(userDoc.data().userName); // Firestore se username set karna
//         }
//       }
//     };

//     fetchUsername();
//   }, [user]);

//   // Capitalize first letter of Firestore username
//   const capitalizedFirestoreUsername = firestoreUsername
//     ? firestoreUsername.charAt(0).toUpperCase() + firestoreUsername.slice(1)
//     : "User";

//   // Close the menu if clicked outside of it
//   useEffect(() => {
//     const handleOutsideClick = (e) => {
//       // Check if the click is outside the menu
//       if (menuRef.current && !menuRef.current.contains(e.target)) {
//         closeMenu(); // Close the menu if clicked outside
//       }
//     };

//     // Only add the event listener if the menu is open
//     document.addEventListener('click', handleOutsideClick);

//     return () => {
//       document.removeEventListener('click', handleOutsideClick);
//     };
//   }, [closeMenu]);

//   const handleUserName = () => {
//     alert(`Hello, ${capitalizedFirestoreUsername}! We hope you're having a great day! 😊`);
//   };

//   const handlePasswordChange = () => {
//     navigate('/password_change');
//     closeMenu();
//   };

//   const handleTracker = () => {
//     navigate('/tracker');
//     closeMenu();
//   };

//   return (
//     <div className='user-menu-container' ref={menuRef}>
//       <div className='user-menu-header'>
//         <h3 className='user-welcome'
//           onClick={handleUserName}>
//           Welcome! {capitalizedFirestoreUsername}
//         </h3>
//       </div>

//       <ul className='user-menu-list'>
//         <li onClick={handlePasswordChange}>
//           <i className="ri-lock-password-line" />
//           Change Password
//         </li>
//         <li onClick={onLogout}>
//           <i className="ri-logout-circle-r-line" />
//           Logout
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default UserMenu;

import React, { useEffect, useRef, useState } from 'react';
import './UserMenu.css';
import { useAuth } from '../firebase/AuthContext';
import PasswordChange from '../PasswordChange/PasswordChange';
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Tracker from '../Tracker/Tracker';
import { doc, getDoc } from 'firebase/firestore'; // Firestore functions
import { db } from '../firebase/firebase'; // Firestore instance

const UserMenu = ({ onLogout }) => {
  const { user, closeMenu } = useAuth();
  const menuRef = useRef(null); // Reference for the menu list container
  const navigate = useNavigate();
  const [firestoreUsername, setFirestoreUsername] = useState(''); // State for Firestore username

  // Fetch username from Firestore
  useEffect(() => {
    const fetchUsername = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid)); // Firestore se user data fetch karna
        if (userDoc.exists()) {
          setFirestoreUsername(userDoc.data().userName); // Firestore se username set karna
        }
      }
    };

    fetchUsername();
  }, [user]);

  // Prioritize displayName, then Firestore username, then default "User"
  const userName = user?.displayName || firestoreUsername || "User";

  // Capitalize first letter of the username
  const capitalizedUserName = userName
    ? userName.charAt(0).toUpperCase() + userName.slice(1)
    : "User";

  // Close the menu if clicked outside of it
  useEffect(() => {
    const handleOutsideClick = (e) => {
      // Check if the click is outside the menu
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        closeMenu(); // Close the menu if clicked outside
      }
    };

    // Only add the event listener if the menu is open
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [closeMenu]);

  const handleUserName = () => {
    alert(`Hello, ${capitalizedUserName}! We hope you're having a great day! 😊`);
  };

  const handlePasswordChange = () => {
    navigate('/password_change');
    closeMenu();
  };

  const handleTracker = () => {
    navigate('/tracker');
    closeMenu();
  };

  return (
    <div className='user-menu-container' ref={menuRef}>
      <div className='user-menu-header'>
        <h3 className='user-welcome'
          onClick={handleUserName}>
          Welcome! {capitalizedUserName}
        </h3>
      </div>

      <ul className='user-menu-list'>
        <li onClick={handlePasswordChange}>
          <i className="ri-lock-password-line" />
          Change Password
        </li>
        <li onClick={onLogout}>
          <i className="ri-logout-circle-r-line" />
          Logout
        </li>
      </ul>
    </div>
  );
};

export default UserMenu;